const galleryItems = [
  { image: "/gallery/wide_interior.jpg", caption: "The bistro", span: "col-span-2 md:col-span-2 md:row-span-2" },
  { image: "/gallery/balcony1.jpg", caption: "Al fresco dining", span: "" },
  { image: "/gallery/balcony2.jpg", caption: "Evenings at Kiplings", span: "" },
  { image: "/gallery/gift_boxes.jpg", caption: "The marketplace", span: "" },
  { image: "/gallery/bakery_rack.jpg", caption: "Shelf displays", span: "" },
];

export const LifestyleGallery = () => {
  return (
    <section id="gallery" className="py-24 md:py-32 bg-[#EEE8DC]" data-testid="lifestyle-gallery-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <p className="text-[#C9A85A] text-sm tracking-[0.2em] uppercase font-body font-semibold mb-3">
            The Experience
          </p>
          <h2 className="font-heading text-4xl md:text-5xl text-[#191646] font-medium tracking-tight mb-4">
            Life at Kiplings
          </h2>
          <p className="text-[#4A5568] font-body max-w-lg mx-auto">
            Where every visit is a story. European bistro charm meets Hyderabad warmth.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              data-testid={`gallery-item-${index}`}
              className={`relative overflow-hidden group cursor-pointer ${item.span} ${
                !item.span ? "aspect-square" : ""
              }`}
            >
              <img loading="lazy"
                src={item.image}
                alt={item.caption}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-[#191646]/0 group-hover:bg-[#191646]/50 transition-all duration-300 flex items-end">
                <p className="text-white font-subheading text-lg italic px-4 pb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {item.caption}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
